import { useEffect, useState } from "react";
import BranchService from "../../services/resource/branchService";
import { useFormik } from "formik";
import ButtonLoading from "../../components/buttonLoading/buttonLoading";
import DropDown from "../../components/dropdown/dropdown";
import { toast } from 'react-toastify';
import OrderService from "../../services/resource/orderService";
import { formatClientCode } from "../../utils/formatClientCode";
import { formatOrder } from "../../utils/formatOrder";
import { useNavigate } from "react-router-dom";
import './styles.css'
import { formatRomaneio } from "../../utils/formatRomaneio";
import InputForm from "../../components/input/input";
import { useAuth } from "../../context/authContext";
import moment from "moment-timezone";
import { formatLocalDate } from "../../utils/formatDate";
import MotoristaService from "../../services/resource/motoristaService";

const initialValues = {
    id: '',
    clientCode: '',
    branchId: '',
    branchCode: '',
    driverName: '',
    driverId: '',
    date: '',
    npsRated: '',
    toggleAdvanced: false,
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
}

function Pedidos() {
    const branchService = new BranchService();
    const orderService = new OrderService();
    const driverService = new MotoristaService();
    const navigate = useNavigate()

    const { user } = useAuth();
    const [order, setOrder] = useState([]);
    const [error, setError] = useState('');
    const [mensagemSucesso, setMensagemSucesso] = useState('');
    const [orders, setOrders] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [minDate, setMinDate] = useState(moment().startOf("day").format("YYYY-MM-DD"));
    const [maxDate, setMaxDate] = useState(moment().startOf("day").format("YYYY-MM-DD"));
    const [branchDelete, setBranchDelete] = useState('');
    const [autorizado, setAutorizado] = useState(true);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [pageSize] = useState(20);
    const [branches, setBranches] = useState([]);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalDeleteAll, setShowModalDeleteAll] = useState(false);
    const [showModalView, setShowModalView] = useState(false);

    const formik = useFormik({
        initialValues: initialValues
    });

    useEffect(() => {
        branchService.findAll().then(response => {
            setBranches(response.data)
        });

        const savedFilters = sessionStorage.getItem('filtroFormulario');
        if (savedFilters) {
            formik.setValues(JSON.parse(savedFilters));
        }

        formik.setFieldValue("branchId", user.branchid);

        loadOrders({ ...formik.values, branchId: user.branchid });

        setCount(1);

    }, []);

    useEffect(() => {
        if (formik.values.branchId) {
            driverService.findAllByBranch(formik.values.branchId).then(response => {
                setDrivers(response.data);
            })
        }
    }, [formik.values.branchId])

    useEffect(() => {
        if (count > 0) {
            loadOrders();
        }
    }, [page]);

    const loadOrders = (values = formik.values) => {
        setLoading(true);

        orderService.findAll(values, pageSize, page).then(response => {
            setOrders(response.data.content);
            setTotalElements(response.data.totalElements);
        }).catch(error => {
            console.error('Erro ao carregar pedidos', error);
        }).finally(() => {
            setTimeout(() => setLoading(false), 400);
        })
    };


    const handleSubmitOrders = (event) => {
        event.preventDefault();
        sessionStorage.setItem('filtroFormulario', JSON.stringify(formik.values));
        setPage(0);
        loadOrders();
    }

    const handlePrevPage = () => {
        if (page > 0) setPage(page - 1);
    };

    const handleNextPage = () => {
        if ((page + 1) * pageSize < totalElements) setPage(page + 1);
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const importFileOrders = () => {
        setLoading(true);
        setError('');

        const formData = new FormData();
        formData.append('file', file)

        if (autorizado) {
            orderService.importOrdersDa(formData).then(response => {
                toast.success("Arquivo importado com sucesso!")
                setLoading(false);
                setFile(null);
                setMensagemSucesso("Arquivo importado com sucesso!")
            }).catch(error => {
                setLoading(false);
                const errorMessage = error?.response?.data?.message || error.message || "Erro desconhecido";
                setError(errorMessage);
                toast.error(errorMessage);
            }).finally(() => { setLoading(false) })
        } else {
            orderService.importOrdersDl(formData, formik.values.branchCode).then(response => {
                toast.success("Arquivo importado com sucesso!")
                setLoading(false);
                setMensagemSucesso("Arquivo importado com sucesso!")
                setFile(null);
            }).catch(error => {
                setLoading(false);
                const errorMessage = error?.response?.data?.message || error.message || "Erro desconhecido";
                setError(errorMessage);
                toast.error(errorMessage);
            }).finally(() => { setLoading(false) })
        }
    }

    const deleteAll = () => {
        setError('');
        setLoadingDelete(true);
        orderService.deleteAllByNps(branchDelete, minDate, maxDate).then(response => {
            toast.success("Pedidos deletados com Sucesso!");
            setShowModalDeleteAll(false);
            setMinDate('');
            setMaxDate('');
        }).catch(error => {
            const errorMessage = error?.response?.data?.message || error.message || "Erro desconhecido";
            setError(errorMessage);
            toast.error(errorMessage);
        }).finally(setLoadingDelete(false));
    }

    const closeModal = () => {
        setShowModal(false);
        formik.setValues(prev => ({ ...prev, branchCode: null, atualiza: null }));
        setFile(null);
        setMensagemSucesso("");
        setError("")
    }
    const closeModalDeleteAll = () => {
        setShowModalDeleteAll(false);
        setMinDate(moment().startOf("day").format("YYYY-MM-DD"));
        setMaxDate(moment().startOf("day").format("YYYY-MM-DD"));
        setBranchDelete(null);
    }

    const onCloseView = () => {
        setShowModalView(false);
        setOrder({})
    }

    const selectedClientUpdate = (order) => {
        navigate(`/nps/nova-avaliacao/${order.branchCode}/${order.clientCode}/${order.id}`)
    }

    const selectedOrder = (order) => {
        setOrder(order);
        setShowModalView(true)
    }

    return (
        <div className="w-full">
            <div>
                <form onSubmit={handleSubmitOrders} className="bg-white rounded-lg shadow-md p-6 mb-8 fade-in">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-semibold text-gray-700">Consulta Pedidos</h2>
                        <button type="button" id="toggleAdvanced" className="text-blue-600 hover:text-blue-800 flex items-center" onClick={() => formik.setValues(prev => ({ ...prev, toggleAdvanced: !formik.values.toggleAdvanced }))}>
                            {!formik.values.toggleAdvanced ?
                                <><i className="fas fa-sliders-h mr-2" /> Avançado</>
                                :
                                <><i className="fas fa-times mr-2" /> Fechar</>
                            }
                        </button>
                    </div>

                    <div>
                        <div className="w-full md:w-3/3 flex flex-col sm:flex-row gap-3">
                            <div className="flex-1">
                                <DropDown
                                    id="cadastroBranchId"
                                    label="Buscar por Filial"
                                    optionValue="id"
                                    optionLabel="name"
                                    name="branchId"
                                    placeholder="Todas"
                                    value={formik.values.branchId}
                                    optional
                                    options={branches}
                                    onChange={formik.handleChange}
                                />
                            </div>
                            <div className="flex-1">
                                <label for="startDate" className="block text-sm font-medium text-gray-700 mb-1">Data Inicial</label>
                                <input
                                    type="date"
                                    id="startDate"
                                    name="startDate"
                                    value={formik.values.startDate}
                                    onChange={formik.handleChange}
                                    className="w-full px-4 py-2 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 datepicker-input" />

                            </div>
                            <div className="flex-1">
                                <label for="startDate" className="block text-sm font-medium text-gray-700 mb-1">Data Final</label>
                                <input
                                    type="date"
                                    id="endDate"
                                    name="endDate"
                                    value={formik.values.endDate}
                                    onChange={formik.handleChange}
                                    className="w-full px-4 py-2 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 datepicker-input" />

                            </div>

                            <div className="flex-1">
                                <DropDown
                                    id="cadastroBranchId"
                                    label="Situação NPS"
                                    optionValue="value"
                                    optionLabel="label"
                                    name="npsRated"
                                    placeholder="Todas as situações"
                                    value={formik.values.npsRated}
                                    options={[{ label: 'Avaliado', value: true }, { label: 'Não Avaliado', value: false }]}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div id="advancedSearch" className={`${!formik.values.toggleAdvanced && 'hidden'} fade-in`}>
                        <div className="w-full md:w-3/3 flex flex-col sm:flex-row gap-3 mt-3">
                            <div className="flex-1">
                                <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Pedido</label>
                                <div className="relative">
                                    <input
                                        type="searchCode"
                                        id="search"
                                        name="id"
                                        placeholder="Digite o código..."
                                        className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={formik.values.id}
                                        onChange={formik.handleChange}
                                    />
                                    <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                </div>
                            </div>
                            <div className="flex-1">
                                <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Cód. Cliente</label>
                                <div className="relative">
                                    <input
                                        type="searchCode"
                                        id="search"
                                        name="clientCode"
                                        placeholder="Digite o código..."
                                        className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={formik.values.clientCode}
                                        onChange={formik.handleChange}
                                    />
                                    <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                </div>
                            </div>
                            {formik.values.branchId && drivers.length > 0 ?
                                <div className='flex-1'>
                                    <DropDown
                                        id="cadastroBranchId"
                                        label="Buscar por Cód Motorista"
                                        label1="name"
                                        optionValue="id"
                                        optionLabel="id"
                                        optionLabel2="name"
                                        placeholder="Selecione um Motorista"
                                        name="driverId"
                                        optional
                                        disabled={loading}
                                        value={formik.values.driverId}
                                        options={drivers}
                                        onChange={formik.handleChange}
                                    />
                                </div>
                                :
                                <div className="flex-1">
                                    <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Cód Motorista</label>
                                    <div className="relative">
                                        <input
                                            id="driverId"
                                            type="text"
                                            name="driverId"
                                            placeholder="Digite o código..."
                                            className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formik.values.driverId}
                                            onChange={formik.handleChange}
                                        />
                                        <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                    </div>
                                </div>
                            }
                            <div className="flex-1">
                                <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Nome Motorista</label>
                                <div className="relative">
                                    <input
                                        id="searchName"
                                        type="text"
                                        name="driverName"
                                        placeholder="Digite o nome do motorista..."
                                        className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={formik.values.driverName}
                                        onChange={formik.handleChange}
                                    />
                                    <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-wrap gap-2 mt-3">
                        <div>
                            <ButtonLoading for="file-upload"
                                type="submit"
                                label="Pesquisar"
                                icon="fas fa-search"
                                color="indigo"
                            />
                        </div>
                        <div>
                            <button id="resetFilters" type="button" onClick={() => formik.setValues(initialValues)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center">
                                <i className="fas fa-redo mr-2"></i> Limpar Filtros
                            </button>
                        </div>
                        {user.roles.includes("NPS_ADMIN") &&
                            <>
                                <div>
                                    <button for="file-upload"
                                        type="button"
                                        className="file-input-label flex items-center justify-center bg-transparent hover:bg-blue-500 text-blue-700 py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                                        onClick={() => setShowModal(true)}
                                    >
                                        <i className="fas fa-file-import mr-2"></i>
                                        Importar Pedidos
                                    </button>
                                </div>
                                <div>
                                    <button for="file-upload"
                                        type="button"
                                        className="file-input-label flex items-center justify-center bg-red-500 hover:bg-red-600 text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                                        onClick={() => setShowModalDeleteAll(true)}
                                    >
                                        <i className="fas fa-trash mr-2"></i>
                                        Deletar Pedidos
                                    </button>
                                </div>
                            </>
                        }
                    </div>
                </form>
                {loading ? (
                    <div className="text-center py-10">
                        <i className="fas fa-spinner fa-spin text-4xl text-indigo-600 mb-4" />
                        <p className="text-gray-600">Carregando pedidos...</p>
                    </div>
                ) : totalElements === 0 ? (
                    <div className="text-center py-10">
                        <i className="fas fa-inbox text-4xl text-gray-400 mb-4" />
                        <p className="text-gray-600">Nenhum pedido encontrado</p>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow overflow-hidden fade-in">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pedido/Romaneio</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Motorista</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">NPS</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {orders.map(order => (
                                        <tr key={order.id}>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <div className="">
                                                    <div className="text-sm font-medium ">{order.id.substring(4)}</div>
                                                    <div className="text-sm text-gray-500">Rom: {formatRomaneio(order.romaneioId)}</div>
                                                </div>

                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <div className="">
                                                    <div className="text-sm font-medium ">{order.clientName}</div>
                                                    <div className="text-sm text-gray-500">{formatClientCode(order.clientCode).substring(5)}</div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatLocalDate(order.createDate)}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <div className="">
                                                    <div className="text-sm font-medium ">{order.romaneioDriverName || "Nome não cadastrado"}</div>
                                                    <div className="text-sm text-gray-500">{order.romaneioDriverId.substring(4)}</div>
                                                </div>

                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {order.npsId !== null ?
                                                    <div className={`px-2 py-1 rounded bg-green-100 text-green-800 font-bold text-center`}>Realizado</div>
                                                    :
                                                    <div className={`px-2 py-1 rounded bg-red-100 text-red-800 font-bold text-center`}>Não Realizado</div>
                                                }
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
                                                {order.npsId === null
                                                    && <button className="text-blue-600 hover:underline text-sm mr-2" onClick={() => selectedClientUpdate(order)}>Avaliar</button>
                                                }
                                                <button className="text-base-600 hover:underline text-sm" onClick={() => selectedOrder(order)}>Ver Pedido</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
                            <div className="text-sm text-gray-600">
                                Mostrando {page * pageSize + 1} a {Math.min((page + 1) * pageSize, totalElements)} de {totalElements} pedidos
                            </div>
                            <div className="flex space-x-2">
                                <button onClick={handlePrevPage} disabled={page === 0} className="px-3 py-1 border rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                                    Anterior
                                </button>
                                <button onClick={handleNextPage} disabled={(page + 1) * pageSize >= totalElements} className="px-3 py-1 border rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                                    Próximo
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div >

            {showModal && (
                <div id="import-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md fade-in grid gap-4">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-medium text-gray-900">Confirmar Importação</h3>
                            <button id="close-modal" className="text-gray-400 hover:text-gray-500" onClick={closeModal}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <ul className="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                                <div className="flex items-center ps-3">
                                    <input
                                        id="horizontal-list-radio-license"
                                        type="radio"
                                        checked={autorizado === true}
                                        value="true"
                                        onChange={() => setAutorizado(true)}
                                        name="list-radio"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                    />
                                    <label htmlFor="horizontal-list-radio-license" className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Distribuidor Autorizado
                                    </label>
                                </div>
                            </li>
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                                <div className="flex items-center ps-3">
                                    <input
                                        id="horizontal-list-radio-id"
                                        type="radio"
                                        checked={autorizado === false}
                                        value="false"
                                        onChange={() => setAutorizado(false)}
                                        name="list-radio"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                    />
                                    <label htmlFor="horizontal-list-radio-id" className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Distribuidor Logístico
                                    </label>
                                </div>
                            </li>
                        </ul>
                        {!autorizado &&
                            <div className="flex-1">
                                <DropDown
                                    id="cadastroBranchId"
                                    label="Informe Filial para Importação"
                                    optionValue="code"
                                    optionLabel="name"
                                    name="branchCode"
                                    value={formik.values.branchCode}
                                    options={branches}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        }
                        <div className="flex-1">
                            <InputForm
                                type="file"
                                label="Selecione o arquivo"
                                accept=".xlsx"
                                onChange={handleFileChange}
                                className="block w-full text-sm text-gray-600 border-1 border-gray-300 rounded px-3 py-2"
                            />

                        </div>

                        {error !== '' &&
                            <div className="flex flex-wrap p-3 bg-red-200 rounded">
                                <label className="text-red-500 text-sm">{error}</label>
                            </div>
                        }
                        {mensagemSucesso !== '' &&
                            <div className="flex flex-wrap p-3 bg-green-200 rounded">
                                <label className="text-green-500 text-sm">{mensagemSucesso}</label>
                            </div>
                        }
                        {loading &&
                            <p className="text-center text-sm text-gray-500 mb-3">Por favor, não feche essa tela até a conclusão.</p>
                        }
                        <div className="flex justify-end space-x-3 mt-4">
                            <ButtonLoading id="cancel-import"
                                color="gray"
                                label="Cancelar"
                                onClick={closeModal}
                                disabled={loading}

                            >
                                Cancelar
                            </ButtonLoading>

                            <ButtonLoading
                                label="Confirmar"
                                color="blue"
                                id="confirm-import"
                                disabled={(loading || file === null)}
                                loading={loading}
                                onClick={() => importFileOrders()}
                            >
                                Confirmar Importação
                            </ButtonLoading>
                        </div>
                    </div>
                </div>
            )}
            {showModalDeleteAll && (
                <div id="import-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg fade-in grid gap-4">
                        <div className="flex justify-between items-center">
                            <h3 className="text-lg font-medium text-gray-900">Deletar Pedidos</h3>
                            <button id="close-modal" className="text-gray-400 hover:text-gray-500" onClick={closeModalDeleteAll}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div className="w-full grid gap-3">

                            <div className="flex-1">
                                <DropDown
                                    id="cadastroBranchId"
                                    label="Informe a filial"
                                    optionValue="id"
                                    optionLabel="name"
                                    name="branchDelete"
                                    value={branchDelete}
                                    options={branches}
                                    onChange={(e) => setBranchDelete(e.target.value)}
                                />

                            </div>
                            <div className="w-full md:w-3/3 flex flex-col sm:flex-row gap-3">
                                <div className="flex-1">
                                    <label for="startDate" className="block text-sm font-medium text-gray-700 mb-1">Data Inicial</label>
                                    <input
                                        type="date"
                                        id="startDate"
                                        name="date"
                                        value={minDate}
                                        onChange={(e) => setMinDate(e.target.value)}
                                        className="w-full px-4 py-2 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 datepicker-input" />

                                </div>
                                <div className="flex-1">
                                    <label for="startDate" className="block text-sm font-medium text-gray-700 mb-1">Data Final</label>
                                    <input
                                        type="date"
                                        id="startDate"
                                        name="date"
                                        value={maxDate}
                                        onChange={(e) => setMaxDate(e.target.value)}
                                        className="w-full px-4 py-2 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 datepicker-input" />

                                </div>
                            </div>
                        </div>

                        {loadingDelete &&
                            <p className="text-center text-sm text-gray-500 mb-3">Por favor, não feche essa tela até a conclusão.</p>
                        }
                        <div className="flex justify-end space-x-3 mt-4">
                            <ButtonLoading id="cancel-import"
                                color="gray"
                                label="Cancelar"
                                onClick={closeModalDeleteAll}
                                disabled={loadingDelete}

                            >
                                Cancelar
                            </ButtonLoading>

                            <ButtonLoading
                                label="Confirmar"
                                color="blue"
                                id="confirm-import"
                                loading={loadingDelete}
                                onClick={() => deleteAll()}
                            >
                                Confirmar Importação
                            </ButtonLoading>
                        </div>
                    </div>
                </div>
            )}
            {showModalView &&
                <div id='viewer-nps' className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-screen px-4 lg:text-left">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={onCloseView} />
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div className="inline-block align-bottom bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">

                            <div className="bg-white px-4 pb-4 sm:p-6 sm:pb-4">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                        Informações do Pedido
                                    </h3>
                                    <button onClick={() => setShowModalView(false)} className="text-gray-400 hover:text-gray-500">
                                        <i className="fas fa-times"></i>
                                    </button>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <div className="space-y-2 text-sm">
                                            <p><span className="text-gray-600">Número do Pedido:</span> <span className="font-medium">{order.id.substring(4)}</span></p>
                                            <p><span className="text-gray-600">Romaneio/Transporte:</span> <span className="font-medium">{formatRomaneio(order.romaneioId)}</span></p>
                                            <p><span className="text-gray-600">Código do Cliente:</span> <span className="font-medium">{formatClientCode(order.clientCode).substring(5)}</span></p>
                                            <p><span className="text-gray-600">Razão Social:</span> <span className="font-medium">{order.clientName}</span></p>
                                            <p><span className="text-gray-600">Nome Fantasia:</span> <span className="font-medium">{order.clientFantasyName}</span></p>
                                            <p><span className="text-gray-600">Filial:</span> <span className="font-medium">{order.branchName} ({order.branchCode})</span></p>
                                            <p><span className="text-gray-600">Data:</span> <span className="font-medium">{formatLocalDate(order.createDate)}</span></p>
                                            <p><span className="text-gray-600">Valor do pedido:</span> <span className="font-medium">{order.orderValue}</span></p>
                                            <p><span className="text-gray-600">Motorista:</span> <span className="font-medium">{order.romaneioDriverId.substring(4)} - {order.romaneioDriverName || "Nome não informado"}</span></p>
                                            <p><span className="text-gray-600">Ajudante 1:</span> <span className="font-medium">{order.orderRomaneioDriverassistant1Id ? order.orderRomaneioDriverassistant1Id.substring(4) : 'Não Informado'} {order.orderRomaneioDriverassistant1Name}</span></p>
                                            <p><span className="text-gray-600">Ajudante 2:</span> <span className="font-medium">{order.orderRomaneioDriverassistant2Id ? order.orderRomaneioDriverassistant2Id.substring(4) : 'Não Informado'} {order.orderRomaneioDriverassistant2Name}</span></p></div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    onClick={() => setShowModalView(false)}
                                    className="mt-3 w-full sm:w-auto inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3"
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}


export default Pedidos;